jQuery(document).ready(function ($) {
    'use strict';

    var $modal = $('.modal');

    $(document.body).on('click', '.modal', function(e) {
        if (e.target !== this) {
            return;
        }
        $modal.removeClass('active');
    });

    $(document.body).on('click', '.modal-open', function(e) {
        var modal_id = $(this).attr('data-modal');
        $modal.removeClass('active');
        $('.modal[data-modal=' + modal_id + ']').addClass('active');
        history.pushState({}, '');
    });

    $(document.body).on('click', '.modal-close', function(e) {
        $modal.removeClass('active');
    });

    window.onpopstate = function() {
        $modal.removeClass('active');
    };

});